import { type FunctionComponent } from 'react';
import { type CategoryBrowseContent } from '../../../../../types/content.types';
import { isCategoryCard } from '../../../../../utils/typeguards/content.typeguards';
import { CategoryBrowseList } from '../../../category-browse-list/category-browse-list.component';
import { CategoryImageTile } from '../../../category-tile/category-tile.component';

export type ShopBySectionProps = {
	categories?: CategoryBrowseContent['categories'];
};

export const ShopBySection: FunctionComponent<ShopBySectionProps> = ({ categories }) => {
	if (!categories) return null;

	return categories.map((shopSection, index) => (
		<div key={index} className="mv6">
			<h3>Shop by {shopSection.title}</h3>
			<CategoryBrowseList
				className="flex-row-ns flex-wrap items-center justify-start ph0 w-auto w-100-ns"
				items={shopSection.items?.filter(isCategoryCard) || null}
				itemTransform={(categoryProps, itemIndex, info) => (
					<CategoryImageTile
						{...categoryProps}
						className="ph2 mb3"
						key={`${categoryProps.id}|${categoryProps.name}`}
						tileClass={`${!info.isLast ? 'bb' : ''}`}
					/>
				)}
			/>
		</div>
	));
};
